export default __webpack_public_path__ + "static/small2-02a7496c5edb90e441a0cb61fba76bfa.jpg";